import { useState } from "react";
import { Plus, X, Settings2, RotateCcw, ChevronUp, ChevronDown } from "lucide-react";
import { DEFAULT_STAGES, stagesOf, stageLabel } from "./ExpansionView";

const small = "bg-brand-page border border-brand-border rounded px-2 py-1 text-xs text-brand-ink focus:outline-none focus:border-brand-primary";

export function StageControls({ x, i, onChange, inputCls }) {
  const [editing, setEditing] = useState(false);
  const stages = stagesOf(x);
  const current = stageLabel(x);
  const setStages = (next) => {
    const clean = next.length ? next : DEFAULT_STAGES;
    const idx = stages.indexOf(current);
    const keep = clean.includes(current) ? current : clean[Math.min(Math.max(idx, 0), clean.length - 1)];
    onChange({ stages: clean, stage: keep });
  };
  const rename = (j, v) => {
    const next = stages.map((s, k) => (k === j ? v : s));
    onChange({ stages: next, stage: stages[j] === current ? v : current });
  };
  const move = (j, d) => { const n = [...stages]; [n[j], n[j + d]] = [n[j + d], n[j]]; onChange({ stages: n, stage: current }); };

  return (
    <div className="mb-2">
      <div className="flex gap-2">
        <select value={stages.includes(current) ? current : stages[0]} onChange={(e) => onChange({ stage: e.target.value, stages })} data-testid={`expansion-stage-${i}`} className={`${inputCls} flex-1`}>
          {stages.map((s, k) => <option key={k} value={s}>{s || `Stage ${k + 1}`}</option>)}
        </select>
        <button type="button" onClick={() => setEditing((v) => !v)} data-testid={`expansion-stages-edit-${i}`} title="Customize stages"
          className={`shrink-0 inline-flex items-center gap-1 px-3 rounded-md border text-xs transition-colors ${editing ? "border-brand-primary text-brand-primary" : "border-brand-border text-brand-muted hover:text-brand-primary"}`}>
          <Settings2 className="h-3.5 w-3.5" /> Stages
        </button>
      </div>
      {editing && (
        <div className="mt-2 rounded border border-brand-border bg-brand-page p-2.5 space-y-1.5" data-testid={`expansion-stages-panel-${i}`}>
          {stages.map((s, j) => (
            <div key={j} className="flex items-center gap-1.5">
              <span className="font-mono text-[10px] text-brand-tertiary w-4">{j + 1}</span>
              <input value={s} onChange={(e) => rename(j, e.target.value)} className={`${small} flex-1`} data-testid={`expansion-stage-name-${i}-${j}`} />
              <button type="button" disabled={j === 0} onClick={() => move(j, -1)} className="p-0.5 text-brand-tertiary hover:text-brand-ink disabled:opacity-30" data-testid={`expansion-stage-up-${i}-${j}`}><ChevronUp className="h-3.5 w-3.5" /></button>
              <button type="button" disabled={j === stages.length - 1} onClick={() => move(j, 1)} className="p-0.5 text-brand-tertiary hover:text-brand-ink disabled:opacity-30" data-testid={`expansion-stage-down-${i}-${j}`}><ChevronDown className="h-3.5 w-3.5" /></button>
              <button type="button" disabled={stages.length <= 2} onClick={() => setStages(stages.filter((_, k) => k !== j))} className="p-0.5 text-brand-tertiary hover:text-brand-neg disabled:opacity-30" data-testid={`expansion-stage-remove-${i}-${j}`}><X className="h-3.5 w-3.5" /></button>
            </div>
          ))}
          <div className="flex items-center justify-between pt-1">
            <button type="button" onClick={() => setStages([...stages, `Stage ${stages.length + 1}`])} data-testid={`expansion-stage-add-${i}`} className="inline-flex items-center gap-1 text-[11px] text-brand-primary"><Plus className="h-3 w-3" /> Add stage</button>
            <button type="button" onClick={() => setStages(DEFAULT_STAGES)} data-testid={`expansion-stage-reset-${i}`} className="inline-flex items-center gap-1 text-[11px] text-brand-tertiary hover:text-brand-ink"><RotateCcw className="h-3 w-3" /> Reset to default</button>
          </div>
        </div>
      )}
    </div>
  );
}
